import { utcToZonedTime } from 'date-fns-tz';

export function toZonedTime (date: number | string | Date) {
  return utcToZonedTime(date, process.env.APP_CONFIG.TIMEZONE);
}

export function getZonedDate (date?: number | string | Date) {
  return toZonedTime(date === undefined ? new Date() : date);
}
